import { render, staticRenderFns } from "./AddBudgetSubType.vue?vue&type=template&id=6b853c91&scoped=true"
import script from "./AddBudgetSubType.vue?vue&type=script&lang=js"
export * from "./AddBudgetSubType.vue?vue&type=script&lang=js"
import style0 from "./AddBudgetSubType.vue?vue&type=style&index=0&id=6b853c91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b853c91",
  null
  
)

export default component.exports